// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Section-module--wrapper--QZVSX","slim":"Section-module--slim--1-Os1","slimTop":"Section-module--slimTop--3j8ds","slimBottom":"Section-module--slimBottom--3ldEb"};